var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookrequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.267,
    height: 80,
    viewBox: "0 0 80.267 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Book_A_request_",
    "data-name": "Book A request\\u200B",
    transform: "translate(-18.742 -18.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M61.29,61.965a12.6,12.6,0,0,1,12.59,12.59h-6.8a5.686,5.686,0,0,0-2.75-5.354A5.8,5.8,0,0,0,55.5,74.555H48.7A12.646,12.646,0,0,1,61.29,61.965Zm-3.618-23.95A9.545,9.545,0,0,1,70.19,50.461a9.375,9.375,0,0,1-8.827,5.861,9.518,9.518,0,0,1-3.69-18.306Zm3.69,6.078v.072a2.714,2.714,0,1,0,0-.072Z",
    transform: "translate(-8.734 -5.428)",
    fill: "#f48a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    d: "M85.246,80.375,99.009,94.139l-4.778,4.778L80.468,85.153ZM74.478,36.162l5.277-3.993A34.1,34.1,0,0,1,32.333,80.233l-.428-.285L36.041,74.6a27.387,27.387,0,0,0,38.722-38.08l-.285-.357,5.277-3.993ZM28.767,28.888a34.164,34.164,0,0,1,45-2.852h0l-4.136,5.277A27.382,27.382,0,0,0,31.192,69.75h0l-5.277,4.136A34,34,0,0,1,28.767,28.888Z",
    transform: "translate(0)",
    fill: "#12355f",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookrequest);
export default __webpack_public_path__ + "static/media/bookrequest.f53e677dbd51e028964e7f60ed819358.svg";
export { ForwardRef as ReactComponent };